module.exports = __webpack_public_path__ + "img/recommed-img9.23350310.jpg";